import {Repository, createRepository} from '@/repositories/Base/Repository'

class ComponentRepository extends Repository {
    endpoint = 'tuevs/components'

    put(id, params) {
        return this.$axios.put(`${this.endpoint}/${id}/update`, params)
    }

    fetch(id) {
        return this.$axios.get(`${this.endpoint}/${id}/show`)
    }
}

export default new ComponentRepository()

export const create = createRepository(ComponentRepository)
